import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.payments.EditCounterpartyPaymentDetailsPopupContent.ThirdStep', {
    bankAccountName: 'Bank account holder name',
    accountNumber: 'Account number',
    bicSwift: 'BIC / Swift code',
    address: 'Address',
    city: 'City',
    country: 'Country',
    postalCode: 'Postal code',
    stateOrProvince: 'State / Province',
    firstName: 'First name',
    lastName: 'Last name',
    companyName: 'Company name',
    sortCode: 'Sort code',
    aba: 'ABA (American Bankers Association) routing number',
    bsb: 'BSB (Bank State Branch) number',
    institutionNumber: 'Institution number',
    incorporationNumber: 'Incorporation number',
    bankCode: 'Bank code',
    branchCode: 'Branch code',
    clabe: 'CLABE (Clave Bancaria Estandarizada) code',
    cnaps: 'CNAPS (China National Advanced Payment System) code',
    iban: 'IBAN',
    ifsc: 'IFSC code',
    inputPlaceholder: 'Enter value...',
    validationErrorMessage: 'Invalid value',
    bankAccountNameValidationError:
        'Bank account name should be 2-200 characters long and should not contain any of the following: {restrictedChars}',
});
